import Page from "./Page";
import HeaderVideo from "./HeaderVideo";

export default class Home extends Page {
	constructor () {
		super();
		new HeaderVideo();
		this.createSwiper();
	}

	createSwiper () {


		this.btnPrev = (document.getElementsByClassName('btn_prev'))[0];
		this.btnNext = (document.getElementsByClassName('btn_next'))[0];

		this.mySwiper = new Swiper('.swiper', {
			direction: 'horizontal',
			loop: false,
			allowTouchMove: true,
			slidesPerView: 1,
			navigation: {
				nextEl: '.btn_next',
				prevEl: '.btn_prev',
			},
			on: {
				slideChangeTransitionEnd: function () {
					this.checkArrowVisibility();
				}.bind(this)
			},
			breakpoints: {
				768: {
					slidesPerView: 3,
				}
			}
		});

		this.checkArrowVisibility();
	}

	checkArrowVisibility () {
		if ( this.mySwiper.isBeginning )
		{
			if ( this.btnPrev.style.display != 'none' )
			{
				this.btnPrev.style.display = 'none';
			}
		}
		else
		{
			if ( this.btnPrev.style.display == 'none' )
			{
				this.btnPrev.style.display = 'block';
			}
		}

		if ( this.mySwiper.isEnd )
		{
			if ( this.btnNext.style.display != 'none' )
			{
				this.btnNext.style.display = 'none';
			}
		}
		else
		{
			if ( this.btnNext.style.display == 'none' )
			{
				this.btnNext.style.display = 'block';
			}
		}
	}
}